import { useRef } from "react";
import { Checkbox, Radio } from "shared/components";
import styles from "../../../styles/service/product-details.module.scss";
import classNames from "classnames/bind";

import { Currency } from "shared/utils/Currency";

const css = classNames.bind(styles);

export const OptionItem = ({
  option,
  onClick,
  onLongPress,
  sameOptions,
  singleOption,
  disabled,
}) => {
  const timerRef = useRef(null);

  const canClick =
    !disabled || (!sameOptions && option.selected) || singleOption;

  const startPress = () => {
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      onLongPress && onLongPress(option);
    }, 500);
  };

  const endPress = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
      canClick && onClick && onClick(option);
    }
  };

  const cancelPress = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  return (
    <div
      className={css({ option: true, selected: option.selected })}
      onMouseDown={startPress}
      onMouseUp={endPress}
      onMouseLeave={cancelPress}
      onTouchStart={startPress}
      onTouchEnd={endPress}
      onTouchCancel={cancelPress}
    >
      <div className="d-flex align-center justify-between w-100">
        <div className="d-flex flex-column mr-30 flex-1">
          <p className={styles.name}>{option.name}</p>
          {option.old_price || option.price ? (
            <>
              {option.promo_price ? (
                <p className={styles.fromPrice}>
                  {Currency.formatCurrency(option.old_price || 0)}
                </p>
              ) : null}
              {Number(option.price) > 0 ? (
                <p className={styles.price}>
                  {Currency.formatCurrency(option.price || 0)}
                </p>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
      {sameOptions && (
        <div
          className={css({ selectedQuantity: true, selected: option.selected })}
        >
          {option.quantity}
        </div>
      )}
      {!sameOptions && singleOption && (
        <div className={styles.optionSelect}>
          <Radio
            key={Math.random()}
            value={option.id}
            checked={option.selected && option.id}
            readOnly
          />
        </div>
      )}
      {!sameOptions && !singleOption && (
        <div className={styles.optionSelect}>
          <Checkbox
            key={Math.random()}
            value={option.id}
            checked={option.selected}
            readOnly
          />
        </div>
      )}
    </div>
  );
};
